import decodeUriComponent from 'decode-uri-component';
import Ad from './Ad';
import ReactModal  from 'react-modal';
import { useEffect, useState } from 'react';
import Btn from './Button';
import External from './Extrenal';
import { useTranslation } from 'react-i18next';
import {getForumDumb} from '../helpers/Utils';
import {  Link } from "react-router-dom";

const ForumTiz = (props) => {
    
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const [isOpen, setForumIsOpen] = useState(false);
    const [currentForum, setCurrentForum] = useState(false);
    const { t } = useTranslation();

    
    const toggleOpen = () => {
        
        setForumIsOpen(!isOpen);
      }
  useEffect(() =>{
        const fetchForum = async () => {
          const forum_str = await getForumDumb();
          console.log("forum_str: " + forum_str);
          setCurrentForum(forum_str);
      };
      fetchForum();
      const handleResize = () => {
                setScreenWidth(window.innerWidth);
                //alert(window.innerWidth);
    
            };
            
      handleResize();
      window.addEventListener('resize', handleResize);

      // Clean up the event listener when the component unmounts
      return () => {
          window.removeEventListener('resize', handleResize);
      };
    }, [])  
      
  const customStyles = {
    content: {
      width:(screenWidth > 800 ) ? '420px' :'100%',
      padding: '5px',
      top: '0',
      left: '0',
      direction: (props.lang == 1) ? 'rtl' : '',
      right: 'auto',
      bottom: '0',
      position: 'absolute',
      marginRight: '',
      transform: '',
    },
  };     

    return ( currentForum == "" ? 'loading forum' :
          <div className=" white_transp_box white_box">
          <h4 id="forum_title">{t('CHAT_TITLE')}</h4>
           
          <div id="forumdump" className="  ">
          {currentForum.map((message, i) => {
            if (i === 0){
              let name = decodeUriComponent(eval(`message.name`)).replace(/\+/g, ' ').replace('שלג', '***');
              let body = decodeUriComponent(eval(`message.body`)).replace(/\+/g, ' ').replace('שלג', '***');
              let time = decodeUriComponent(eval(`message.time`)).replace(/\+/g, ' ');
              if (body.length > 900) {body = body.slice(0,900);}
              return  (
                <div className="  message" key={i}  a_key={i}>
                  <div className="time">{time}</div>
                  <div className="name" dangerouslySetInnerHTML={{__html: name}}></div>
                  
                  <div className="body"  dangerouslySetInnerHTML={{__html: body}}></div>
                </div>
              )
            }
            
          })}
          
           
          </div>
           <Btn btnOnClick={() => toggleOpen(true)} btnTitleText={t("CHAT_TITLE")}  img={(props.lang == 1)? "ArrowLeft" : "ArrowRight"}>
                    
            </Btn> 
          
          <ReactModal
            
            isOpen={isOpen}
            contentLabel="Example Modal"
            style={customStyles}
            onRequestClose={() => toggleOpen(false)}

          >
            <Btn btnOnClick={() => toggleOpen(false)} btnTitleText={""}  img={"X"} cssClasses="float-start">
                    
            </Btn>
            <div className="sidepopup">
            <External src={"https://v2013.02ws.co.il/small/?section=chatmobile.php&lang=" + props.lang} width="400" height="95%" className={props.cssClasses}/>
            </div>
          </ReactModal>
    </div>
    );
}

export default ForumTiz; 